module.exports = __webpack_public_path__ + "img/31af367a4fcb37c749d6b3497ea06eb3.png";